import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M4.666 6.699h6.665v-1.4H4.666z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.56 13.81q-.426.309-.826.601c-.518.381-.995.744-1.4 1.09v-4.105C3.568 11.25 0 9.818 0 5.955 0 1.864 4 .5 8 .5s8 1.364 8 5.455c0 3.195-3.568 5.777-6.44 7.855m-.826-1.13v-2.63l-1.346-.052c-1.758-.07-3.315-.437-4.387-1.113-.993-.626-1.6-1.522-1.6-2.93 0-1.48.672-2.409 1.791-3.044C4.396 2.226 6.122 1.9 8 1.9c1.879 0 3.604.325 4.809 1.01 1.119.635 1.791 1.564 1.791 3.044 0 1.393-1.028 2.834-2.83 4.392-.862.747-1.816 1.45-2.757 2.13z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
BubbleRoundOutlinedSize16Glyph.displayName = 'BubbleRoundOutlinedSize16Glyph';
